module.exports = __webpack_public_path__ + "static/media/Vector.b263b947.svg";